import dataCategories from '@services/categories';
import ProductAnalysis from '@templates/ProductAnalysis';
import { getPostsByCategoriesAndSize } from '@utils/postGroupUtil';
import { filterOnlyNeededDataPostGroup } from '@utils/postUtils';
import { getSliderBroker } from '@utils/sortBroker';
import {
  // createThumbnailForBrokerList,
  createThumbnailForTopic,
} from '@utils/thumbnailUtil';
import { getLandingPageById } from 'cache-service/landingPage';
import { getAllTopicGroupCache } from 'cache-service/topicGroup';
import { getAllForexBrokerDataCache } from 'cache-service/wpBrokerData';
import { getFeaturePostsCache } from 'cache-service/wpGroupPost';
import { getPostByCategories, getPostByExcludeCategories } from 'cache-service/wpPost';
import {
  getAllProductAnalysis,
  getMainProductAnalysisInfoSelector,
} from 'cache-service/wpProductAnalysis';
import { getAllProductBigPicture } from 'cache-service/wpProductBigPicture';
import React from 'react';

export const getStaticProps = async ({ pageNextJs }) => {
  //menu feature posts
  const featurePostGroups = await getFeaturePostsCache();

  //broker
  const forexBrokersData = await getAllForexBrokerDataCache();
  const newSlickBrokers = getSliderBroker(forexBrokersData);

  const landingPagesResp = await getLandingPageById(pageNextJs.originalId);
  const page = landingPagesResp.data.content;
  const pageContext = {
    id: page.acf.page_product_analysis.ID,
    title: page.title,
    description: page.acf.description,
  };

  //allWordpressWpProductAnalysis
  let productAnalysisRes = await getAllProductAnalysis();

  productAnalysisRes = productAnalysisRes.data.content
    .map((pa) => getMainProductAnalysisInfoSelector(pa))
    .sort((a, b) => a.date - b.date);
  productAnalysisRes = {
    allWordpressWpProductAnalysis: { nodes: productAnalysisRes },
  };

  // allWordpressWpProductBigPicture
  let productBigPictureRes = await getAllProductBigPicture();
  productBigPictureRes = productBigPictureRes.data.content
    .map((pbp) => ({
      id: pbp.id,
      date: pbp.date,
      wordpress_id: pbp.id,
      acf: pbp.acf,
    }))
    .sort((a, b) => b.date - a.date);
  productBigPictureRes = {
    allWordpressWpProductBigPicture: {
      nodes: productBigPictureRes,
    },
  };

  const productAnalysis = productAnalysisRes.allWordpressWpProductAnalysis.nodes.find(
    (item) => item.wordpress_id === pageContext.id
  );

  const productCategoryId = productAnalysis.acf.product_category;
  const productCategory = dataCategories.find((item) => item.id === productCategoryId);

  const postSelector = (post) => ({
    id: post.id,
    excerpt: post.excerpt,
    slug: post?.slug,
    title: post.title,
    thumbnail: post.thumbnail,
    date: post.date,
    author: post.author,
    date_gmt: post.date,
  });

  let kienthucPosts = await getPostByCategories({ categories: ['kien-thuc'] });
  kienthucPosts = kienthucPosts.data.content
    .filter((post) => post.categories.includes(productCategoryId))
    .map((post) => postSelector(post))
    .sort((a, b) => a.date - b.date)
    .slice(0, 12);
  const gapPostLength = 12 - kienthucPosts.length;
  const gapPost = await getPostByExcludeCategories({
    categories: [3737],
    size: gapPostLength,
  });

  //data post group
  const slugProductCatogry = productCategory?.slug;
  // tin tuc
  let postsCateTintuc = await getPostsByCategoriesAndSize(['tin-tuc', slugProductCatogry], 5, 300);
  if (postsCateTintuc.length < 5) {
    const fillGapPosts = await getPostsByCategoriesAndSize(
      ['tin-tuc'],
      5 - postsCateTintuc.length,
      300
    );
    postsCateTintuc = postsCateTintuc.concat(fillGapPosts);
  }
  postsCateTintuc = filterOnlyNeededDataPostGroup(postsCateTintuc);

  //Phan tich nhan dinh
  let postsCatePhantich = await getPostsByCategoriesAndSize(
    ['phan-tich-nhan-dinh', slugProductCatogry],
    5,
    300
  );
  postsCatePhantich = filterOnlyNeededDataPostGroup(postsCatePhantich);

  //Kien thuc chung forex
  let postsCateKienthucForex = await getPostsByCategoriesAndSize(['forex', 'kien-thuc'], 5, 300);
  postsCateKienthucForex = filterOnlyNeededDataPostGroup(postsCateKienthucForex);

  // postId: post.id,
  //       author: matchingUser,
  kienthucPosts = kienthucPosts.concat(gapPost.data.content);

  // topic
  const topicRes = await getAllTopicGroupCache();
  let topics = topicRes.data.content.filter((item) => {
    return !item.acf.hidden_in_home;
  });
  topics = await createThumbnailForTopic(topics, 250);
  topics.sort((a, b) => b.date.localeCompare(a.date));
  const newTopics = topics.slice(0, 10).map((t) => {
    return {
      id: t.id,
      acf: {
        path: t.acf.path,
        name: t.acf.name,
        icon: t.acf.icon,
      },
    };
  });

  return {
    props: {
      data: JSON.stringify({
        ...productAnalysisRes,
        ...productBigPictureRes,
      }),
      pageContext,
      posts: {
        postsCateTintuc,
        postsCatePhantich,
        postsCateKienthucForex,
      },
      newTopics: newTopics,
      newSlickBrokers,
      slugProductCatogry: slugProductCatogry || '',
      featurePostGroups: featurePostGroups,
      // tintucPosts,
    },
  };
};

const AnalysisPage = ({
  data,
  pageContext,
  posts,
  newTopics,
  newSlickBrokers,
  slugProductCatogry,
  featurePostGroups,
}) => {
  return (
    <ProductAnalysis
      newSlickBrokers={newSlickBrokers}
      data={JSON.parse(data)}
      pageContext={pageContext}
      posts={posts}
      newTopics={newTopics}
      users={[]}
      slugProductCatogry={slugProductCatogry}
      featurePostGroups={featurePostGroups}
    />
  );
};

export default AnalysisPage;
